import { render, staticRenderFns } from "./UsersAllDropDown.vue?vue&type=template&id=2f97fad2&scoped=true&"
import script from "./UsersAllDropDown.vue?vue&type=script&lang=ts&"
export * from "./UsersAllDropDown.vue?vue&type=script&lang=ts&"
import style0 from "./UsersAllDropDown.vue?vue&type=style&index=0&id=2f97fad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97fad2",
  null
  
)

export default component.exports